import { render, staticRenderFns } from "./OnboardingCompanyLegalDataForm.vue?vue&type=template&id=e26d9ae2"
import script from "./OnboardingCompanyLegalDataForm.vue?vue&type=script&lang=js"
export * from "./OnboardingCompanyLegalDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports